import { useMemo, useState } from 'react'

// this is something conceptual I'm trying out here
// as the number of pages of data increase/decrease we track how many there are
// and we return different caching values based on that
// so for larger data sets we'll keep the data around longer and refresh less frequently
export function usePagedQueryScaledCaching() {
  const [numPages, setNumPages] = useState(0)

  const cacheTTL = useMemo(() => {
    // if there's only one page, we only need one api call, so don't bother caching
    if (numPages <= 1) {
      return 0
    }

    // 5 pages is 100 records or less, so cache it for a few minutes
    if (numPages <= 5) {
      return 60_000 * 2
    }

    // 5 minutes is the max we cache the data
    return 60_000 * 5
  }, [numPages])

  return {
    cacheTTL,
    setNumPages
  }
}
